import React from 'react';
import GPSKpiTile from './GPSKpiTile';

const IconBolt = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2 3 14h9l-1 8 10-12h-9z" />
  </svg>
);
const IconPause = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" />
  </svg>
);
const IconCancel = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" /><path d="m15 9-6 6" /><path d="m9 9 6 6" />
  </svg>
);
const IconStack = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 2 9 5-9 5-9-5z" /><path d="m3 12 9 5 9-5" /><path d="m3 17 9 5 9-5" />
  </svg>
);

/**
 * "Encours à fin de période" — ENCOURS block.
 *
 * Buckets are kept disjoint so they sum to the total open backlog:
 *  - En attente = STANDBY tickets
 *  - En cours   = open (status_category != DONE) tickets that are NOT standby
 *  - Total ouverts = all open tickets = En cours + En attente
 * "Encours à fin de période" is a presentation proxy over the open tickets of the
 * filtered period (the API does not expose a true point-in-time snapshot).
 */
const GPSStockBlock = ({ stats, fullWidth = false }) => {
  const enAttente = stats.standByTickets.length;
  const totalOuverts = stats.ongoingTickets.length;
  const enCours = Math.max(0, totalOuverts - enAttente);

  const prevEnAttente = stats.previous.standByTickets.length;
  const prevTotalOuverts = stats.previous.ongoingTickets.length;
  const prevEnCours = Math.max(0, prevTotalOuverts - prevEnAttente);

  return (
    <section className="bg-gradient-to-b from-[#f4f6f9] to-[#fbfcfd] dark:from-[#191b20] dark:to-[#151619] border border-[#e2e7ee] dark:border-gray-900 rounded-2xl p-4 h-full flex flex-col">
      <div className="flex items-center gap-3 mb-3">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[#3a4a63] text-white flex-shrink-0">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z" /><circle cx="12" cy="13" r="3.5" />
          </svg>
        </span>
        <div className="min-w-0">
          <div className="flex items-center gap-2.5 flex-wrap">
            <span className="text-base font-bold text-gray-900 dark:text-white">Encours à fin de période</span>
            <span className="text-[10px] font-bold tracking-wider text-[#3a4a63] dark:text-gray-300 bg-[#e4e9f0] dark:bg-gray-700 px-2 py-0.5 rounded">
              ENCOURS
            </span>
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400 text-left">
            Tickets ouverts au dernier jour de la période
          </div>
        </div>
      </div>

      <div className={`grid gap-2.5 flex-1 auto-rows-fr ${fullWidth ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4' : 'grid-cols-2'}`}>
        <GPSKpiTile label="En cours" value={enCours} previousValue={prevEnCours} icon={IconBolt} description="Tickets ouverts en toujours en cours de traitement à la fin de la période, hors tickets mis en Standby." />
        <GPSKpiTile label="En attente" value={enAttente} previousValue={prevEnAttente} icon={IconPause} description="Tickets ouverts toujours en attente (ex-« standby ») à la fin de la période. Exclus du total des En cours." />
        <GPSKpiTile label="Annulés" value={stats.abandonedTickets.length} previousValue={stats.previous.abandonedTickets.length} icon={IconCancel} description="Tickets clôturés sans résolution sur la période (annulés, rejetés, declined)." />
        <GPSKpiTile
          label="Total ouverts"
          value={totalOuverts}
          icon={IconStack}
          fill={{ gradient: 'linear-gradient(135deg,#5b3df0,#7858ff)', valueColor: '#fff', labelColor: '#d8ccfb', infoColor: '#d8ccfb' }}
          additionalInfo={`${enCours} en cours + ${enAttente} en attente`}
          description="Ensemble des tickets encore ouverts à la fin de la période (en cours + en attente)."
        />
      </div>
    </section>
  );
};

export default GPSStockBlock;
